import type { ReactNode } from "react";
import type { Icon } from "@/components/icons";
import { cn } from "@/lib/utils";

type ProductFormSectionProps = {
  icon?: Icon;
  title: string;
  description?: string;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
};

export function ProductFormSection({
  icon: IconComponent,
  title,
  description,
  action,
  children,
  className,
}: ProductFormSectionProps) {
  return (
    <section
      className={cn("brand-card flex flex-col gap-4 p-5 sm:p-6", className)}
    >
      <div className="flex flex-wrap items-start justify-between gap-3 border-secondary/20 border-b pb-4">
        <div className="flex items-start gap-3">
          {IconComponent ? (
            <div className="flex size-10 shrink-0 items-center justify-center rounded-xl bg-primary/20 text-secondary">
              <IconComponent />
            </div>
          ) : null}
          <div className="flex flex-col gap-0.5">
            <h3 className="font-display text-foreground text-lg leading-tight">
              {title}
            </h3>
            {description ? (
              <p className="text-muted-foreground text-sm">{description}</p>
            ) : null}
          </div>
        </div>
        {action}
      </div>
      {children}
    </section>
  );
}
